import { formatter } from './formatter'

export type RelativeYearDateParams = {
  timeZone?: string
  locale?: string
  format?: 'timestamp' | 'date' | Intl.DateTimeFormatOptions
  relativeYears?: number
  relativeDays?: number
}

export const getRelativeYearDate = (params: RelativeYearDateParams = {}): Date | number | string => {
  const { relativeYears = 0, relativeDays = 0, timeZone, format, locale } = params

  const now = new Date()
  let currentDate: Date

  if (timeZone) {
    const options: Intl.DateTimeFormatOptions = { timeZone }
    const currentDateISOString = now.toLocaleString('en-US', options).split(',')[0]
    currentDate = new Date(currentDateISOString)
  } else {
    currentDate = now
  }

  const targetYear = currentDate.getFullYear() + relativeYears

  const targetDate = new Date(targetYear, currentDate.getMonth(), currentDate.getDate() + relativeDays)

  return formatter(targetDate, params)
}
